
export const formatCurrency = (data) => {
    if (data.currency) {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: data.currency.code
        }).format(data.customerPaymentDetail.amount)
    } else {
        return `NPR ${data?.customerPaymentDetail.amount}`
    }
}

export const formatAmount = (amount, currencyCode) => {
    if (currencyCode) {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencyCode
        }).format(amount)
    } else {
        return `NPR ${amount}`
    }
}
